const cdnLinks = [
  {
    type: "css",
    url: "https://cdnjs.cloudflare.com/ajax/libs/codemirror/5.63.1/codemirror.min.css",
  },
  {
    type: "css",
    url: "https://cdnjs.cloudflare.com/ajax/libs/codemirror/5.63.1/theme/monokai.min.css",
  },
  {
    type: "js",
    url: "https://cdnjs.cloudflare.com/ajax/libs/codemirror/5.63.1/codemirror.min.js",
  },
  {
    type: "js",
    url: "https://cdnjs.cloudflare.com/ajax/libs/codemirror/5.63.1/mode/javascript/javascript.min.js",
  },
  {
    type: "js",
    url: "https://cdnjs.cloudflare.com/ajax/libs/codemirror/5.63.1/mode/python/python.min.js",
  },
  {
    type: "js",
    url: "https://cdnjs.cloudflare.com/ajax/libs/codemirror/5.63.1/mode/xml/xml.min.js",
  },
  {
    type: "js",
    url: "https://cdnjs.cloudflare.com/ajax/libs/codemirror/5.63.1/mode/css/css.min.js",
  },
  {
    type: "js",
    url: "https://cdnjs.cloudflare.com/ajax/libs/codemirror/5.63.1/mode/htmlmixed/htmlmixed.min.js",
  },
  {
    type: "js",
    url: "https://cdnjs.cloudflare.com/ajax/libs/js-beautify/1.15.1/beautify.min.js",
  },
  {
    type: "js",
    url: "https://cdnjs.cloudflare.com/ajax/libs/js-beautify/1.15.1/beautify-css.min.js",
  },
  {
    type: "js",
    url: "https://cdnjs.cloudflare.com/ajax/libs/js-beautify/1.15.1/beautify-html.min.js",
  },
];

function loadCSS(url) {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`link[href="${url}"]`)) {
      resolve();
      return;
    }
    const linkElement = document.createElement("link");
    linkElement.rel = "stylesheet";
    linkElement.href = url;
    linkElement.onload = resolve;
    linkElement.onerror = reject;
    document.head.appendChild(linkElement);
  });
}

function loadScript(url) {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${url}"]`)) {
      resolve();
      return;
    }
    const scriptElement = document.createElement("script");
    scriptElement.src = url;
    scriptElement.onload = resolve;
    scriptElement.onerror = reject;
    document.head.appendChild(scriptElement);
  });
}
async function loadCDNs() {
  const page = window.location.pathname;
  if (
    page.includes("music_factory") ||
    page.includes("art_factory") ||
    page.includes("vernatics") ||
    page.includes("compiler") ||
    page.includes("sketch") ||
    page.includes("factory")
  ) {
    for (const link of cdnLinks) {
      if (link.type === "css") {
        await loadCSS(link.url);
      } else if (link.type === "js") {
        await loadScript(link.url);
      }
    }
  }
}

const loadedCdn = loadCDNs();
export default loadedCdn;
